import * as action from "../reducers/retireeNewsletterReducer";
import axios, { authHeader } from "../../services/HTTPService";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchDetails = async (dispatch) => {
  return axios
    .get(API_URL + `/api/medicare-newsletters`, {
      headers: authHeader(),
      params: {
        'filters[current_newsletter][$eq]': true,
      }
    })
    .then(({ data }) => {
      // Get the first item from the array since current_newsletter should be unique
      const currentNewsletter = data?.data?.[0] ? { data: data.data[0] } : { data: null };
      dispatch(action.setRetireeNewsletterDetail(currentNewsletter));
    })
    .catch((error) => {
      dispatch(
        action.setRetireeNewsletterError({ error: error?.response?.data?.error?.message })
      );
    });
};

export const update = async (dispatch, id, body) => {
  return axios
    .put(API_URL + `/api/medicare-newsletters/${id}`, body, { headers: authHeader() })
    .then(({ data }) => {
      dispatch(action.setRetireeNewsletter({ data }));
    })
    .catch((error) => {
      dispatch(
        action.setRetireeNewsletterError({ error: error?.response?.data?.error?.message })
      );
    });
};